import React from "react";
import styles from "./styles";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import familyImage from "../../assets/images/bitmap.png";
export const Slider = () => {
  const classes = styles();
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.textContainer}>
          <Typography
            variant="h4"
            color="initial"
            className={classes.titleStyle}
          >
            Compara y elige el mejor plan para ti y tu familia
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid className={classes.bannerContainer} container justify="center">
            <Grid item className={classes.paragraphContainer}>
              <Typography component="p" className={classes.textParagraph}>
                Cotiza hoy mismo un plan de medicina prepagada y disfruta de
                nuestros beneficios
              </Typography>
            </Grid>
            <Grid item className={classes.imageContainer}>
              <img src={familyImage} alt="Imagen de falimia" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
